import React, { FC, useEffect, useState } from 'react';
import Skillbuilder from '../Skillbuilder';
import Header from '../ContentList/header';
import contentfulClient from '../../models/Contentful';
import { PageLoader } from '../../HOC/Page/WithPage';

const FleischerScholars: FC<any> = () => {
  const [skillbuilders, setSkillbuilders] = useState<any>();
  const [header, setHeader] = useState<any>();
  const skillbuilderFleischer = async () => {
    const response = await contentfulClient.getEntries({
      content_type: 'skillbuilder',
      'fields.specialType': 'Fleischer Scholars',
      order: ['sys.createdAt'],
    });
    return response;
  };
  const headerFleischer = async () => {
    const response = await contentfulClient.getEntries({
      content_type: 'header',
      'fields.friendlyName': 'Fleischer Scholars',
      limit: 1,
    });
    return response.items[0];
  };
  useEffect(() => {
    const getContentful = async () => {
      const skillbuilders = await skillbuilderFleischer();
      const header = await headerFleischer();
      setSkillbuilders(skillbuilders);
      setHeader(header);
    };
    getContentful();
  }, []);
  if (header && skillbuilders) {
    return (
      <>
        <h1 className="m-4 has-text-centered">{header.fields.heading}</h1>
        <Header title={header.fields.title} description={header.fields.description} />
        <div>
          {skillbuilders.items.map((item: any) => {
            item.fields.internship = true;
            return <Skillbuilder {...item} internship />;
          })}
        </div>
      </>
    );
  }
  return <PageLoader />;
};

export default FleischerScholars;
